// extracted by mini-css-extract-plugin
export default {"root":"style_root__Sm4w2","avatar":"style_avatar__2jdls"};